<div class="wave-container bottom-right">
  @for (wave of waves; track wave.speed) {
    <div
      class="wave"
      [style.animation-duration]="wave.speed + 's'"
      [style.opacity]="wave.opacity"
    >
      <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path [attr.d]="wave.path" />
      </svg>
      <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path [attr.d]="wave.path" />
      </svg>
    </div>
  }
</div>

<div class="wave-container top-left">
  @for (wave of wavesTopLeft; track wave.speed) {
    <div
      class="wave"
      [style.animation-duration]="wave.speed + 's'"
      [style.opacity]="wave.opacity"
    >
      <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path [attr.d]="wave.path" />
      </svg>
      <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path [attr.d]="wave.path" />
      </svg>
    </div>
  }
</div>
